export const sorts = {
  NAME: 'first_name',
  SCORE: 'score',
}

export const base = {
  lang: {
    thousandsSep: ','
  },
  chart: {
    margin: [10, 10, 10, 10],
    spacing: [10, 10, 10, 10],
  },
  title: {
    text: null,
  },
  tooltip: {

  },
  plotOptions: {
    bar: {
      dataLabels: {
        enabled: true
      },
      zoneAxis: 'y',
      zones: null,
      cursor: 'pointer',
      events: {},
    },
    scatter: {
      marker: {
        // 'url(/src/images/bacon.svg)'
        symbol: null,
        width: 40,
        height: 40,
        lineWidth: 4,
        lineColor: "blue",
      },
    }
  },
  legend: {
    enabled: false,
  },
  credits: {
    enabled: false
  },
  xAxis: {
    categories: null,
    title: {
      text: null
    }
  },
  yAxis: {
    min: 0,
    title: {
      text: 'score',
      align: 'high'
    },
    labels: {
      overflow: 'justify'
    }
  },
  series: null,
}

export default { base, sorts }